import React from "react";
import {
  useNotify,
  useDataProvider,
  useTranslate,
  useRefresh,
} from "react-admin";
import { Button, Chip } from "@material-ui/core";
import { green, orange } from "@material-ui/core/colors";
import { get } from "lodash";

import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import PauseCircleFilledIcon from "@material-ui/icons/PauseCircleFilled";

const StatusField = ({ source, record, admin = true }) => {
  const notify = useNotify();
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const status = get(record, source);
  const opposite = status === "active" ? "suspended" : "active";
  const handleClick = () =>
    dataProvider
      .update("bookmaker-channels/change-status", {
        data: {
          ...record,
          status: status === "active" ? "suspended" : "active",
        },
      })
      .then(({ success }) => {
        refresh();
        notify(
          translate("resources.bookmaker-channels.messages.status_changed")
        );
      })
      .catch(({ error: { message } }) => notify(message, "warning"));
  return (
    <Button
      onClick={admin ? handleClick : (e) => e.stopPropagation()}
      color="primary"
      style={{
        padding: 0,
      }}
      title={
        admin
          ? translate(
              `resources.bookmaker-channels.messages.change_status_to_${opposite}`
            )
          : null
      }
    >
      <Chip
        icon={
          (admin &&
            (status === "active" ? (
              <PauseCircleFilledIcon style={{ color: "white" }} />
            ) : (
              <PlayCircleFilledIcon style={{ color: "white" }} />
            ))) ||
          null
        }
        style={{
          backgroundColor: status === "suspended" ? orange[500] : green[500],
          cursor: admin ? "pointer" : null,
          color: "white",
          margin: 0,
        }}
        label={translate(`resources.bookmaker-channels.status.${status}`)}
      />
    </Button>
  );
};

export default StatusField;
